import styled from 'styled-components';
import { Family } from '../Css/Font';
import { ColorsVariables } from '../../assets/styles/colors';
import { SCREEN } from '../../assets/styles/constants';

export const MainTitle = styled.h1`
	${Family.ProximaNovaNormal};
	color: #353944;
	font-size: 48px;
	letter-spacing: 2px;
	padding: 0px;
	margin: 0px;
	text-align: left;
	text-transform: uppercase;
	z-index: 1;
	
	${SCREEN.SMALL} {
		font-size: 26px;
	}
`;

export const WhiteSpaceNormal = styled.span`
	white-space: normal;
`;

export const MediumTitle = styled.h2`
	
	color: #353944;
	font-size: 28px;
	text-align: center;
	letter-spacing: 2px;
	line-height: 1 !important;
	${SCREEN.SMALL} {
		font-size: 22px;
		letter-spacing: 1px;
		line-height: 1.6 !important;
		text-align: left;
	}
`;

export const Description = styled.div`
	width: 100%;
	${Family.ProximaNovaNormal};
	color: #353944;
	font-size: 24px;
	box-sizing: border-box;
	${props => (props.margintop ? 'margin-top: 40px;' : '')};
	${props => (props.textAlign ? `text-align: ${props.textAlign};` : 'text-align: center;')};
	z-index: 1;
	${props => props.noWrap && 'white-space: nowrap'};
	
	${props => (props.limit ? 'padding: 0px 10vw;' : '')};
	
	${SCREEN.MEDIUM} {
		font-size: 18px;
		padding: 0;
		line-height: 1.6 !important;
		${props => (props.textAlign ? `text-align: ${props.textAlign};` : 'text-align: left;')};
	}
`;

Description.Title = styled.p`
	color: #353944;
	text-align: left;
`;

Description.Paragraph = styled(Description.Title)`
	font-weight: ${props => (props.Bold ? '600' : '400')};
	font-size: 16px;
	color: ${props => (props.color ? '#ffffff' : '#353944')};
`;

Description.PhoneNumber = styled.a`
	${Family.ProximaNovaNormal};
	color: rgb(53, 57, 68, .6);
	font-size: 16px;
	text-decoration: none;
	margin-top: 0px;
	${SCREEN.MEDIUM} {
		font-size: 16px;
	}
`;
Description.Address = styled(Description.PhoneNumber)`
	text-align: left;
	${Family.ProximaNovaNormal};
	color: rgb(53, 57, 68, .6);
	font-size: 16px;
	text-decoration: none;
	margin-top: 0px;
	${SCREEN.MEDIUM} {
		font-size: 16px;
	}
`;

Description.errorMessage = styled.div`
	text-align: left;
	${Family.ProximaNovaNormal};
	padding: 1px 15px;
	font-size: 13px;
	color: #ff9999;
`;

Description.popUpMessage = styled.p`
	${Family.ProximaNovaNormal};
	font-size: 14px;
	font-weight: 400;
	color: black;
`;

export const HeavyText = styled.span`
	
	${props => (props.nowrap && 'white-space: nowrap;')};
	${props => (props.fontSize ? `font-size: ${props.fontSize}px` : '')};
`;

export const ItalicText = styled.span`
	font-style: italic;
`;

export const BigText = styled.span`
	font-size: 28px;
`;

export const GreenText = styled.span`
	color: ${ColorsVariables.MainGreen};
`;

export const PurpleText = styled.span`
	color: ${ColorsVariables.MainPurple};
`;
